import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "input", "status", "loggableType" ]

  processInput(event) {
    this.showSearching();
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    let currentSearchTerm = this.inputTarget.value;

    if (currentSearchTerm.length == 0 || currentSearchTerm.length > 2) {
      this.timeout = setTimeout(() => {
        this.formTarget.requestSubmit();
        this.hideSearching();
      }, 500);
    } else {
      this.hideSearching();
    }
  };

  filterByLoggableType(event) {
    // Update the hidden field value
    this.loggableTypeTarget.value = event.target.checked ? event.target.value : '';
    
    // Submit the form to trigger server-side filtering
    this.formTarget.requestSubmit();
  }

  showSearching() {
    this.statusTarget.classList.remove("d-none");
  };

  hideSearching() {
    this.statusTarget.classList.add("d-none");
  }

  submitForm(event) {
    event.target.form.requestSubmit();
  }
}

